module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/classic_tablet-c0bd0ca8c677be4ae93d20c7f341f066.webp";